// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8131) return "static/css/8131.20e8c825b26ea8faffab.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"001f255414a23092be02","1412":"83971b4df2c901ec0bdb","1904":"001f255414a23092be02","4983":"001f255414a23092be02","6454":"001f255414a23092be02"}[chunkId] + ".chunk.css";
};